import React, { useEffect, useState } from "react"
import "./ProductsRecommendations.css"
import { useDispatch, useSelector } from "react-redux"
import ProductCard from "../ProductCard/ProductCard"
import Slider from "react-slick"
import axios from "axios"
import Cookies from "universal-cookie"

import Utils from "../../utils/Utils"
import { SetImgPrefix, SetUrlPrefix } from "../../state/actions"

const ProductsRecommendations = (props) => {
  const { recommendation } = props
  const display = useSelector((state) => state.config.display)
  const isMobile = useSelector((state) => state.isMobile)
  const configFilters = useSelector((state) => state.config.filters)
  const sort = useSelector((state) => state.sort)
  const settings = {
    dots: false,
    infinite: false,
    speed: 200,
    slidesToShow: isMobile || display === "half-screen" ? 2 : 4,
    slidesToScroll: isMobile || display === "half-screen" ? 2 : 4,
  }

  const [products, setProducts] = useState([])
  const [showRec, setShowRec] = useState(true)
  const cookies = new Cookies()

  const lastClickedProduct =
    cookies.get("ASLastClickedProduct") !== undefined
      ? cookies.get("ASLastClickedProduct")
      : null

  const dispatch = useDispatch()

  useEffect(() => {
    if (recommendation?.recommender?.recommender?.type === "custom") {
      dispatch(SetUrlPrefix(window.location.origin))
      setProducts(recommendation?.recommender?.recommender?.content?.products)
    } else if (recommendation?.recommender?.recommender?.type === "query") {
      const rec = recommendation?.recommender
      axios
        .get(rec?.recommender?.baseUrl + "?" + rec?.recommender?.queryString)
        .then((res) => {
          if (res?.data?.data?.length > 0) {
            dispatch(SetUrlPrefix(res?.data?.header?.urlPrefix))
            dispatch(SetImgPrefix(res?.data?.header?.imagePrefix))
            setProducts(res?.data?.data)
          }
        })
    } else if (
      recommendation?.recommender?.recommender?.type === "queryTemplate"
    ) {
      if (!!lastClickedProduct) {
        const rec = recommendation?.recommender?.recommender
        const queryParams = new URLSearchParams(rec?.queryString)
        const newQueryString = new URLSearchParams()
        // eslint-disable-next-line no-unused-expressions
        queryParams.entries().forEach((element) => {
          const name = element[0]
          const value = element[1]
          const prop = value?.replace("{:context.item.", "").replace("}", "")
          if (prop?.toLowerCase()?.includes("category")) {
            if (prop === "sameCategory") {
              newQueryString.append(name, lastClickedProduct?.categories?.[0])
            } else if (prop === "prevCategory") {
              const splitted = lastClickedProduct?.categories?.[0]?.split("/")
              if (splitted && splitted?.length > 1) {
                newQueryString.append(
                  name,
                  splitted[splitted?.length - 2] + "*"
                )
              } else {
                newQueryString.append(name, lastClickedProduct?.categories?.[0])
              }
            }
          }
          if (prop?.toLowerCase()?.includes("price")) {
            newQueryString.append(
              name,
              lastClickedProduct?.pricing?.sellingPrice
            )
          }
          if (lastClickedProduct?.data?.[prop?.toLowerCase()]) {
            newQueryString.append(
              name,
              lastClickedProduct?.data?.[prop?.toLowerCase()]
            )
          }
        })
        axios
          .get(rec?.baseUrl + "?" + decodeURI(newQueryString.toString()))
          .then((res) => {
            if (res?.data?.data?.length > 0) {
              dispatch(SetUrlPrefix(res?.data?.header?.urlPrefix))
              dispatch(SetImgPrefix(res?.data?.header?.imagePrefix))
              setProducts(res?.data?.data)
            } else {
              setShowRec(false)
            }
          })
      } else {
        setShowRec(false)
      }
    }
  }, [recommendation])

  function parseProduct(prod) {
    if (prod?.data) return prod
    return {
      data: { ...prod, image: [prod.image] },
      pricing: { sellingPrice: prod?.price, listingPrice: prod?.price },
      header: {
        id: prod?.id,
      },
    }
  }
  if (!showRec) {
    return <></>
  }
  return (
    <div className="products-recommendations">
      <div className="label "> Trending Products </div>
      <Slider {...settings}>
        {products.map((item, index) => (
          <ProductCard value={parseProduct(item)} key={"product_" + index} />
        ))}
      </Slider>
    </div>
  )
}

export default ProductsRecommendations
